export default [
    {
      path: '/mentionMe',
      component: () => import('@views/mentionMe'),
      children: (pre => [
        {
          path: pre+'/send-index',
          component: () => import('@views/mentionMe/sendIndex'),
          name: 'sendIndex',
          meta: {
            isLogin: false,
            isFooterShow: false,
            title : '提我领券'
          }
        },
        {
          path: pre+'/recipt-index',
          component: () => import('@views/mentionMe/recipientIndex'),
          name: 'recipientIndex',
          meta: {
            isLogin: false,
            isFooterShow: false,
            title : '提我领券'
          }
        }
      ])('/mentionMe')
    }
  ]
  